import { gql, useMutation } from 'urql';
import type { SubmitFormInput, SubmitFormResponse } from '@entities/leadCollector';

export const SUBMIT_FORM = gql`
  mutation SubmitForm($formLink: String!, $submissionInfo: String!) {
    submitForm(input: { formLink: $formLink, submissionInfo: $submissionInfo }) {
      eventName
      submissionFormStatus
      dateStart
      dateEnd
    }
  }
`;

export const useSubmitForm = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<SubmitFormResponse, SubmitFormInput>(SUBMIT_FORM);

  const submitForm = (variables: SubmitFormInput) => {
    return executeMutation(variables);
  };

  return { data, error, fetching, submitForm };
};
